import { ExperienceMode } from '@/generated/graphql';
import { atom } from 'jotai';

export const changeTopNavColourAtom = atom<ExperienceMode | undefined>(undefined);
